export default __webpack_public_path__ + "static/media/noPresenterImage.bcfc5ee6.svg";